import React from "react";

import { Route, Routes } from "react-router-dom";

import { withProjectRedirect } from "Hocs/withProjectRedirect";
import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import UserDetailsNoOrg from "../access/UserDetails/UserDetailsNoOrg";

import InvitationCreate from "./InvitationCreate";
import InvitationDetails from "./InvitationDetails";
import InvitationError from "./InvitationError/InvitationError";
import Page from "./Page";
import ProjectAccessList from "./ProjectAccessList";
import UserDetails from "./UserDetails";

const ProjectSettingsRoutes = () => {
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);

  return (
    <Page>
      <Routes>
        <Route path="new" element={<InvitationCreate />} />
        <Route
          path="invitations/:invitationId"
          element={
            <InvitationError>
              <InvitationDetails />
            </InvitationError>
          }
        />
        <Route
          path="users/:userId"
          element={
            !organizationEnabled ? <UserDetails /> : <UserDetailsNoOrg />
          }
        />
        <Route path="" element={<ProjectAccessList />} />
      </Routes>
    </Page>
  );
};

export default withProjectRedirect(ProjectSettingsRoutes);
